// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__aBl75","tooltiptext":"Tooltip_tooltiptext__lrC4U","title":"Tooltip_title__stc4a"};